<section class="flex-row flex-gap-10 flex-col-lt-sm flex-100 flex-fill-item">
  <mat-card appearance="outlined" class="flex-1-1-auto flex-fill-item">
    <mat-card-title>Registru C.M. {{ user()?.judet_id | judet}}</mat-card-title>
    <mat-card-content>
      <form novalidate (submit)="$event.preventDefault(); onSearch(searchFormCMJ().value(), 'cmj')">
        <mat-form-field class="flex-1-1-auto flex-fill-item"><mat-label>Caută medic</mat-label>
          <input matInput [formField]="searchFormCMJ" type="text">
          <mat-icon matSuffix>search</mat-icon>
          <mat-hint align="start">Se pot folosi: Nume / Prenume / CNP / CUIM</mat-hint>
        </mat-form-field>
      </form>
    </mat-card-content>
    <mat-card-actions class="flex-row flex-align-end-center">
      <!-- TODO: de revazut fxlayout se afiseaza aiurea -->
      <button mat-raised-button color="primary" (click)="medicNou()">Adaugă un medic nou</button>
      <span class="flex-spacer"></span>
      <button mat-button [disabled]="searchFormCMJ().invalid() || isLoading()" (click)="clearSearch('cmj')">Șterge rezultate</button>
      <button mat-button [disabled]="searchFormCMJ().invalid() || isLoading()" color="primary" (click)="onSearch(searchFormCMJ().value(), 'cmj')">Căutare</button>
    </mat-card-actions>
  </mat-card>

  <mat-card appearance="outlined" class="flex-1-1-auto flex-fill-item">
    <mat-card-title>Registru Național</mat-card-title>
    <mat-card-content>
      <form novalidate (submit)="$event.preventDefault(); onSearch(searchFormCMR().value(), 'cmr')">
        <section>
          <mat-form-field class="flex-100 flex-fill-item"><mat-label>Caută medic în registrul național</mat-label>
            <input matInput [formField]="searchFormCMR" type="text" />
            <mat-icon matSuffix>search</mat-icon>
            <mat-hint align="start">Se pot folosi: Nume / Prenume / CNP / CUIM</mat-hint>
          </mat-form-field>
        </section>
      </form>
    </mat-card-content>
    <mat-card-actions class="flex-row flex-align-end-center flex-col-lt-sm">
      <button mat-button [disabled]="searchFormCMR().invalid() || isLoading()" (click)="clearSearch('cmr')">Șterge rezultate</button>
      <button mat-button [disabled]="searchFormCMR().invalid() || isLoading()" color="primary" (click)="onSearch(searchFormCMR().value(), 'cmr')">Căutare</button>
    </mat-card-actions>
  </mat-card>
</section>